import { Component, Input } from '@angular/core';
import { formatLabel } from '@project/shared/utils/labels/js/labels';
var SearchResultListComponent = /** @class */ (function () {
    function SearchResultListComponent() {
        this.patternName = 'SearchResultList';
    }
    SearchResultListComponent.prototype.hasResults = function () {
        return this.resultTab.totalCount && this.resultTab.totalCount > 0;
    };
    SearchResultListComponent.prototype.trackResultBy = function (index, item) {
        return item.title + "-" + index;
    };
    SearchResultListComponent.prototype.trackPermissionRowBy = function (index, item) {
        return index;
    };
    Object.defineProperty(SearchResultListComponent.prototype, "noResultsTitle", {
        get: function () {
            return formatLabel(this.resultTab.tab.noResultsTitle, this.searchText || '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchResultListComponent.prototype, "noResultsText", {
        get: function () {
            return this.resultTab.tab.noResultsText;
        },
        enumerable: true,
        configurable: true
    });
    SearchResultListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-search-result-list',
                    template: "<div class=\"m-search-result-list\"\r\n\t data-t-name=\"SearchResultList\">\r\n\t<ng-container *ngIf=\"hasResults(); else  noResults\">\r\n\t\t<div class=\"m-search-result-list__item\"\r\n\t\t\t *ngFor=\"let result of resultTab.results; trackBy: trackResultBy\">\r\n\t\t\t<div class=\"m-search-result-list__type\">\r\n\t\t\t\t<span class=\"m-search-result-list__type-item\" [innerHTML]=\"result.typeLabel\"></span>\r\n\t\t\t\t<span *ngIf=\"result.topParentLabel\" class=\"m-search-result-list__type-item\" [innerHTML]=\"result.topParentLabel\"></span>\r\n\t\t\t</div>\r\n\t\t\t<cov-link class=\"m-search-result-list__title\"\r\n\t\t\t\t\t  [class]=\"result.title.class\"\r\n\t\t\t\t\t  [text]=\"result.title.text\"\r\n\t\t\t\t\t  [href]=\"result.title.href\"\r\n\t\t\t\t\t  [target]=\"result.title.target\"\r\n\t\t\t\t\t  [rel]=\"result.title.rel\"\r\n\t\t\t\t\t  [title]=\"result.title.title\"\r\n\t\t\t\t\t  [modifier]=\"result.title.modifier\"></cov-link>\r\n\t\t\t<ng-template [ngIf]=\"result.tags && result.tags.length > 0\">\r\n\t\t\t\t<cov-tag *ngFor=\"let tag of result.tags; trackBy: trackPermissionRowBy;\" [modifier]=\"tag.modifier\" [class]=\"tag.class\" [icon]=\"tag.icon\" [text]=\"tag.text\"></cov-tag>\r\n\t\t\t</ng-template>\r\n\t\t\t<p class=\"m-search-result-list__description\" [innerHTML]=\"result.description.text | highlight : searchText\"></p>\r\n\t\t</div>\r\n\t</ng-container>\r\n\t<ng-template #noResults>\r\n\t\t<cov-search-no-results\r\n\t\t\t*ngIf=\"!hasResults()\"\r\n\t\t\t[noResultsTitle]=\"noResultsTitle\"\r\n\t\t\t[noResultsText]=\"noResultsText\"\r\n\t\t\t[showButton]=\"false\">\r\n\t\t</cov-search-no-results>\r\n\t</ng-template>\r\n</div>\r\n"
                }] }
    ];
    SearchResultListComponent.propDecorators = {
        resultTab: [{ type: Input }],
        searchText: [{ type: Input }]
    };
    return SearchResultListComponent;
}());
export { SearchResultListComponent };
//# sourceMappingURL=search-result-list.component.js.map